import { CollectionType, useListBrowserUtils } from '@ts-private/list-browser';
import { useTranslation } from 'react-i18next';
import { citiesStore } from '../store';
import { useEffect } from 'react';
import { getCityTypeLabel } from '../functions';
import { CityType } from '../constants';

const CityBrowserFilters = () => {
  const { t } = useTranslation();

  const { updateCollection } = useListBrowserUtils(citiesStore);

  useEffect(() => {
    const typeOptions = Object.values(CityType).map(value => ({
      value,
      label: getCityTypeLabel(t, value)
    }));
    updateCollection(typeOptions, 'type', CollectionType.Filter);
  }, [t, updateCollection]);

  return null;
};

export default CityBrowserFilters;
